export default function TSeriesVerficationController(
  $scope,
  TSeriesService,
  $filter,
  $q,
  $timeout,
  gettextCatalog
) {
  'ngInject';

  // variable
  var self = this;
  $scope.validationSummary = {};
  $scope.error = false;
  $scope.errortext = gettextCatalog.getString('Oops! Somthing went wrong.');
  $scope.csvexportData = [];
  var timer = null;

  self.init = function () {
    $scope.loading = true;
    TSeriesService.getValidationSummary()
      .then(
        function (response) {
          $scope.validationSummary = response.data;
          self.getChartready();
        },
        function (error) {
          $scope.error = true;
        }
      )
      .finally(function () {
        $scope.loading = false;
      });

    TSeriesService.getValidationDetail().then(
      function (response) {
        var validationDetails = response.data;
        var csvData = self.getCsvData(validationDetails);
        $scope.csvexportData = csvData;
      },
      function (error) {
        $scope.csvexportData = [];
      }
    );

    // run refresh
    timer = $timeout(function () {
      self.init();
    }, 60000); // 1 min
  };

  $scope.getvalidationDetails = function () {
    // use defeerd object so download will wait till callback done
    var deferred = $q.defer();
    var csvData = [];
    TSeriesService.getValidationDetail().then(
      function (response) {
        var validationDetails = response.data;
        csvData = self.getCsvData(validationDetails);

        deferred.resolve(csvData);
      },
      function (error) {
        deferred.reject();
      }
    );

    return deferred.promise;
  };

  self.getChartready = function () {
    var chart = new AmCharts.makeChart('vericationChart', {
      type: 'pie',
      theme: 'light',
      innerRadius: '70%',
      pullOutRadius: '30%',
      outlineAlpha: 0,
      dataProvider: [{
          state: 'Verfied',
          count: $scope.validationSummary.active,
          color: '#12981c'
        },
        {
          state: 'Unverfied',
          count: $scope.validationSummary.inactive,
          color: '#d2d2d2'
        }
      ],
      valueField: 'count',
      titleField: 'state',
      colorField: 'color',
      labelColorField: 'color',
      radius: '45%',
      startDuration: 0,
      depth3D: 0,
      labelText: '',
      balloonText: "<b><span style='font-size:14px'><b>[[value]]</b><br>([[percents]]%)</span>",
      angle: 0,
      allLabels: [{
        y: '40%',
        align: 'center',
        size: 22,
        bold: true,
        text: $scope.validationSummary.active,
        color: '#12981c'
      }],
      legend: {
        data: [{
          title: 'Total:',
          value: $scope.validationSummary.active + $scope.validationSummary.inactive,
          color: '#fff'
        }],
        position: 'bottom',
        autoMargins: false,
        align: 'center',
        fontSize: 18
      },
      export: {
        enabled: false
      }
    });
  };

  $scope.verficationgetCsvFileName = function () {
    var fileName = gettextCatalog.getString('T_series_Verfication_');
    var d = new Date();
    var date =
      d.getFullYear() + '_' + (d.getMonth() + 1) + '_' + d.getDate() + '_' + d.getHours() + '-' + d.getMinutes();

    fileName += date;
    return fileName + '.csv';
  };

  self.getCsvData = function (veficatioDetailList) {
    var CsvData = [];

    var headers = {
      ESN: 'ESN',
      Name: 'Name',
      Make: 'Make',
      Model: 'Model',
      'Last Communication': 'Last Communication',
      'Previous Communication': 'Previous Communication',
      Delta1: 'Delta 1 (minutes)',
      Delta2: 'Delta 2 (minutes)'
    };

    CsvData.push(headers);

    for (var i = 0; i < veficatioDetailList.length; i++) {
      var esn = veficatioDetailList[i].esn;
      var name = veficatioDetailList[i].name;
      var make = veficatioDetailList[i].make;
      var model = veficatioDetailList[i].model;
      var lastcom = $filter('TableDateFilter')(veficatioDetailList[i].lastCommunication);
      var precom = $filter('TableDateFilter')(veficatioDetailList[i].previousCommunication);
      var delta1 = veficatioDetailList[i].lastCommDeltaMinutes;
      var delta2 = veficatioDetailList[i].previousCommDeltaMinutes;

      var csvObject = {
        ESN: esn,
        Name: name,
        Make: make,
        Model: model,
        'Last Communication': lastcom,
        'Previous Communication': precom,
        Delta1: typeof delta1 === 'number' ? delta1.toFixed(2) : '',
        Delta2: typeof delta2 === 'number' ? delta2.toFixed(2) : ''
      };

      CsvData.push(csvObject);
    }

    return CsvData;
  };

  self.init();

  // cancel the timer when navigate away.
  $scope.$on('$destroy', function () {
    if (timer) {
      $timeout.cancel(timer);
    }
  });
}